export const COMPANY_TO_ADVISOR = 'COMPANY_TO_ADVISOR';
export const COMPANY_TO_BOARD_MEMBER = 'COMPANY_TO_BOARD_MEMBER';
export const COMPANY_TO_CONTRACTOR = 'COMPANY_TO_CONTRACTOR';
export const COMPANY_TO_MANAGER = 'COMPANY_TO_MANAGER';
export const COMPANY_TO_OWNER = 'COMPANY_TO_OWNER';
export const COMPANY_TO_PARTNER = 'COMPANY_TO_PARTNER';
export const COMPANY_TO_RESELLER = 'COMPANY_TO_RESELLER';